<template>
  <div class="message">
    <div class="form" v-if="!hasVerifyShop">
      <h2 class="name">绑定信息</h2>
      <div class="form-item-wrapper">
        <div class="form-item">
          <input
            max-length="11"
            placeholder="请输入手机号"
            type="tel"
            v-model="phone"
          />
        </div>
      </div>
      <div class="form-item-wrapper">
        <div class="form-item code">
          <div class="input-wrapper">
            <input
              maxlength="6"
              placeholder="请输入验证码"
              type="tel"
              v-model="codeNum"
            />
          </div>
          <button
            :class="{ 'code-sended': codeSended }"
            @click="getCode"
            class="get-code"
          >
            {{ codeText }}
          </button>
        </div>
      </div>
      <button class="btn" @click="submit">绑定</button>
    </div>
    <div class="success" v-else>
      <div class="ico">
        <van-icon color="#449BBF" size="30" name="success" />
      </div>
      <div class="title">绑定成功</div>
      <div class="txt">
        专车预约的订单消息会以公众号消息发送您绑定的微信中，请注意查收，并根据提示保证订单正常完成
      </div>
      <button class="btn" @click="close">我已知晓</button>
    </div>
    <popup :close-on-click-overlay="false" v-model="popShow">
      <div class="pop">
        <div class="title">已绑定</div>
        <div class="text">
          抱歉，查询到您的号码已绑定模板消息微信，是否重新绑定，重新绑定后将是当前登陆微信接收专车订单消息
        </div>
        <div class="btn">
          <button @click="close">知道了</button>
          <button @click="close">重新绑定</button>
        </div>
      </div>
    </popup>
  </div>
</template>
<script>
import { Icon, Popup } from 'vant'
let flag = false
export default {
  components: {
    VanIcon: Icon, Popup
  },
  data () {
    return {
      popShow: false,
      hasVerifyShop: false,
      phone: '',
      show: false,
      seconds: 60,
      codeNum: '',
      codeText: '获取验证码',
      codeSended: false
    }
  },
  props: {
    code: {
      type: String
    }
  },
  created () {
    if (!this.code) {
      this.goAuth()
    }
  },
  methods: {
    goAuth () {
      location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxdc3a62d8972a0132&redirect_uri=${encodeURIComponent(process.env.VUE_APP_BASE_URL + 'bindMessage')}&response_type=code&scope=snsapi_base#wechat_redirect`)
    },
    close () {
      location.replace(`${process.env.VUE_APP_BASE_URL}bindMessage`)
    },
    async submit () {
      if (!this.phone) {
        this.$toast('请输入您的手机号')
        return false
      }
      if (!/^1[3,4,5,6,7,8,9]\d{9}$/.test(this.phone)) {
        this.$toast('请输入正确的手机号')
        return false
      }
      if (!this.codeNum) {
        this.$toast('请输入验证码')
        return false
      }
      this.$toast.loading('正在验证...')
      this.submitHandler()
    },
    async submitHandler () {
      const res = await this.$http.post(`/shop/api/driver/bind`, {
        phone: this.phone,
        sms_code: this.codeNum,
        code: this.code
      })
      if (res.status === 200) {
        const { code, msg } = res.data
        this.$toast.clear()
        if (code === 0) {
          this.hasVerifyShop = true
        } else if (code === 30) {
          // 已绑定
          this.popShow = true
        } else {
          this.$toast(msg)
        }
      }
    },
    // 获取验证码
    async getCode () {
      if (!this.phone) {
        this.$toast('请输入您的手机号')
        return false
      }
      if (!/^1[3,4,5,6,7,8,9]\d{9}$/.test(this.phone)) {
        this.$toast('请输入正确的手机号')
        return false
      }
      if (this.codeSended) {
        this.$toast('验证码已发送,请稍候...')
        return false
      }
      if (flag) {
        return false
      }
      flag = true
      const res = await this.$http.post(`/shop/api/driver/sms_code`, { phone: this.phone })
      if (res.status === 200) {
        flag = false
        const { code, msg } = res.data
        if (code === 0) {
          this.$toast('验证码发送成功')
          this.codeSended = true
          this.countDown()
        } else {
          flag = false
          this.$toast(msg)
        }
      }
    },
    goback () {
      document.addEventListener('WeixinJSBridgeReady', function () {
        window.WeixinJSBridge.call('closeWindow')
      }, false)
      window.WeixinJSBridge.call('closeWindow')
    },
    /**
* 倒计时
*/
    countDown () {
      const timer = setInterval(() => {
        this.seconds--
        this.codeText = `(${this.seconds})s 后重新获取`
        if (this.seconds <= 0) {
          clearInterval(timer)
          this.seconds = 60
          this.codeText = '获取验证码'
          this.codeSended = false
        }
      }, 1000)
    }
  }
}
</script>
<style lang='less' scoped>
.message {
  min-height: 100vh;
  position: relative;
  box-sizing: border-box;
  padding: 0.02rem;
  &::after {
    content: '';
    position: absolute;
    top: -1rem;
    left: -1.8rem;
    right: -1.8rem;
    background: #449bbf;
    border-radius: 0 0 50% 50%;
    height: 4rem;
  }
  .pop {
    width: 6.1rem;
    border-radius: 0.14rem;
    background: #fff;
    box-sizing: border-box;
    padding: 0.1rem 0.3rem 0.3rem;
    font-size: 0.26rem;
    color: #2e2e2e;
    position: relative;
    z-index: 3;
    .title {
      line-height: 1rem;
      height: 1rem;
      text-align: center;
      font-weight: bold;
      font-size: 0.3rem;
    }
    .text {
      text-align: center;
      line-height: 0.45rem;
      padding: 0 0.15rem;
    }
    .btn {
      margin: 0.4rem 0.3rem 0 0.3rem;
      .flex-between;
      button {
        width: 2.08rem;
        line-height: 0.74rem;
        height: 0.74rem;
        background: #4899ff;
        border-radius: 0.37rem;
        text-align: center;
        color: #fff;
        font-size: 0.26rem;
        &:last-child {
          background: #ff893b;
        }
      }
    }
  }
  .success {
    padding-top: 0.9rem;
    position: relative;
    z-index: 2;
    .title {
      font-size: 0.35rem;
      text-align: center;
      font-weight: bold;
      height: 1rem;
      color: #fff;
      .flex-center;
    }
    .ico {
      width: 0.8rem;
      height: 0.8rem;
      border-radius: 50%;
      background: #fff;
      .flex-center;
      margin: 0 auto;
    }
    .txt {
      padding-top: 0.9rem;
      font-size: 0.26rem;
      text-align: center;
      width: 4.7rem;
      margin: 0 auto;
      color: #449bbf;
    }
    .btn {
      width: 6.3rem;
      line-height: 0.72rem;
      text-align: center;
      font-size: 0.26rem;
      color: #fff;
      height: 0.72rem;
      background: #449bbf;
      border-radius: 0.08rem;
      margin: 0.5rem auto;
      display: block;
    }
  }
  .form {
    position: relative;
    z-index: 2;
    margin: 2rem 0.3rem 0.3rem;
    background: #fff;
    border-radius: 0.1rem;
    padding: 0.3rem 0;
    .name {
      z-index: 2;
      padding-top: 0.8rem;
      text-align: center;
      font-size: 0.32rem;
      font-weight: normal;
      color: #fff;
      position: absolute;
      top: -2rem;
      left: 0;
      right: 0;
    }
    .form-item-wrapper {
      width: 5.5rem;
      margin: 0 auto;
      display: flex;
      align-items: center;
      height: 0.7rem;
      margin-bottom: 0.2rem;
      box-sizing: border-box;
      padding: 0 0.1rem;
      .hairline-surround(@color: #7c7b7b, @radius: 0.08rem);
      .title {
        font-size: @fz22;
        padding: 0.2rem 0;
        color: @base;
        width: 0.9rem;
        font-weight: 500;
      }
    }
    .form-item {
      width: 100%;
      height: 0.8rem;
      .flex-between;
      font-size: @fz24;
    }
    .form-item input {
      width: 100%;
      height: 100%;
      color: @base;
      &::-webkit-input-placeholder {
        color: #888;
      }
    }
    .code {
      .flex-between;
      .input-wrapper {
        width: 60%;
      }
      .get-code,
      .code-sended {
        width: 2rem;
        height: 0.54rem;
        font-size: @fz26;
        color: #3498db;
        background: #e5f4fd;
      }

      .code-sended {
        color: #ccc;
      }
    }
    .btn {
      width: 6.3rem;
      line-height: 0.72rem;
      text-align: center;
      font-size: 0.26rem;
      color: #fff;
      height: 0.72rem;
      background: #449bbf;
      border-radius: 0.08rem;
      margin: 0.5rem auto;
      display: block;
    }
  }
}
</style>
